
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';
import SEOHead from '../../../components/SEO/SEOHead';

export default function Product2Page() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedImage, setSelectedImage] = useState(0);
  const [selectedSize, setSelectedSize] = useState('3.8');

  const seoData = {
    title: 'پیت ماس کانادایی پریمیوم - بستر کشت طبیعی گلخانه سبز آریا',
    description: 'پیت ماس کانادایی اصل با کیفیت بالا. بستر کشت طبیعی مناسب برای کشت نشاء، گلخانه، هیدروپونیک. خرید مستقیم از واردکننده.',
    keywords: 'پیت ماس کانادایی، پیت ماس اصل، بستر کشت نشاء، خاک گلخانه، پیت ماس پریمیوم، کوکوپیت، بستر هیدروپونیک، کشت بدون خاک، خاک آماده',
    ogImage: 'https://public.readdy.ai/ai/img_res/0bc960564ed9f26d391455d6cc3cbddf.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "پیت ماس کانادایی پریمیوم",
      "description": "بستر کشت طبیعی و ارگانیک از پیت ماس کانادایی با کیفیت بالا مناسب برای کشت نشاء و گلخانه",
      "image": [
        "https://readdy.ai/api/search-image?query=Canadian%20premium%20peat%20moss%20professional%20horticultural%20substrate%20high%20quality%20growing%20medium%20clean%20white%20background%20product%20photography%20natural%20organic%20material&width=800&height=600&seq=peat-1&orientation=landscape",
        "https://readdy.ai/api/search-image?query=peat%20moss%20texture%20close%20up%20natural%20organic%20growing%20medium%20sustainable%20agriculture%20material%20fibrous%20structure&width=800&height=600&seq=peat-2&orientation=landscape"
      ],
      "brand": {
        "@type": "Brand",
        "name": "گلخانه سبز آریا"
      },
      "manufacturer": {
        "@type": "Organization",
        "name": "گلخانه سبز آریا"
      },
      "sku": "PEAT-MOSS-001",
      "mpn": "PM3.8-2024",
      "gtin": "1234567890124",
      "category": "بسترهای کشت گلخانه",
      "offers": {
        "@type": "Offer",
        "url": "https://ariagreenhouse.com/products/2",
        "priceCurrency": "IRR",
        "price": "320000",
        "priceValidUntil": "2024-12-31",
        "availability": "https://schema.org/InStock",
        "seller": {
          "@type": "Organization",
          "name": "گلخانه سبز آریا"
        },
        "itemCondition": "https://schema.org/NewCondition",
        "warranty": "P12M"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "203",
        "bestRating": "5",
        "worstRating": "1"
      },
      "review": [
        {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "author": {
            "@type": "Person",
            "name": "سارا احمدی"
          },
          "reviewBody": "پیت ماس فوق‌العاده‌ای بود. نشاء‌هام خیلی بهتر رشد کردن. کیفیت عالی و قیمت مناسب."
        }
      ],
      "additionalProperty": [
        {
          "@type": "PropertyValue",
          "name": "حجم",
          "value": "3.8 کیوبیک فوت"
        },
        {
          "@type": "PropertyValue",
          "name": "رطوبت",
          "value": "45-55%"
        },
        {
          "@type": "PropertyValue",
          "name": "pH",
          "value": "3.5-4.5"
        },
        {
          "@type": "PropertyValue",
          "name": "درجه تجزیه",
          "value": "H2-H4"
        },
        {
          "@type": "PropertyValue",
          "name": "منشأ",
          "value": "کانادا"
        }
      ]
    }
  };

  const productImages = [
    'https://readdy.ai/api/search-image?query=Canadian%20premium%20peat%20moss%20professional%20horticultural%20substrate%20high%20quality%20growing%20medium%20clean%20white%20background%20product%20photography%20natural%20organic%20material&width=600&height=450&seq=peat-main-1&orientation=landscape',
    'https://readdy.ai/api/search-image?query=peat%20moss%20texture%20close%20up%20natural%20organic%20growing%20medium%20sustainable%20agriculture%20material%20fibrous%20structure%20detailed%20view&width=600&height=450&seq=peat-main-2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=peat%20moss%20bale%20packaging%20Canadian%20premium%20quality%20horticultural%20growing%20medium%20professional%20agriculture%20white%20background&width=600&height=450&seq=peat-main-3&orientation=landscape',
    'https://readdy.ai/api/search-image?query=seedling%20growing%20in%20peat%20moss%20substrate%20greenhouse%20cultivation%20healthy%20plant%20growth%20natural%20growing%20medium&width=600&height=450&seq=peat-main-4&orientation=landscape'
  ];

  const sizes = [
    { size: '3.8', volume: '3.8 کیوبیک فوت', price: '۳۲۰,۰۰۰ تومان', originalPrice: '۳۸۰,۰۰۰ تومان' },
    { size: '5.5', volume: '5.5 کیوبیک فوت', price: '۴۵۰,۰۰۰ تومان', originalPrice: '۵۲۰,۰۰۰ تومان' },
    { size: '7', volume: '7 کیوبیک فوت', price: '۵۸۰,۰۰۰ تومان', originalPrice: '۶۸۰,۰۰۰ تومان' }
  ];

  const relatedProducts = [
    {
      id: 1,
      name: 'کوکوپیت پریمیوم',
      price: '۱۵۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=premium%20coconut%20coir%20substrate%20blocks%20for%20greenhouse%20cultivation%20professional%20agricultural%20growing%20medium%20clean%20white%20background%20high%20quality%20product%20photography&width=300&height=200&seq=coco-related&orientation=landscape'
    },
    {
      id: 3,
      name: 'نخ UV گلخانه',
      price: '۸۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=UV%20resistant%20greenhouse%20twine%20rope%20for%20plant%20support%20professional%20agricultural%20equipment%20white%20background%20modern%20product%20photography&width=300&height=200&seq=uv-twine-related&orientation=landscape'
    },
    {
      id: 4,
      name: 'توری ضد تریپس',
      price: '۱۲۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=anti-thrips%20insect%20screen%20mesh%20for%20greenhouse%20protection%20fine%20mesh%20agricultural%20netting%20white%20background%20professional%20product%20photography&width=300&height=200&seq=thrips-net-related&orientation=landscape'
    }
  ];

  const tabs = [
    { id: 'overview', name: 'نمای کلی', icon: 'ri-eye-line' },
    { id: 'specifications', name: 'مشخصات', icon: 'ri-file-list-3-line' },
    { id: 'usage', name: 'راهنمای استفاده', icon: 'ri-book-open-line' },
    { id: 'applications', name: 'کاربردها', icon: 'ri-tools-line' },
    { id: 'benefits', name: 'مزایا', icon: 'ri-star-line' }
  ];

  const selectedProduct = sizes.find(s => s.size === selectedSize) || sizes[0];

  return (
    <div className="min-h-screen">
      <SEOHead {...seoData} />
      <Header />
      
      {/* Breadcrumb */}
      <section className="bg-gray-50 py-4 pt-24 mt-20">
        <div className="container mx-auto px-4 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm">
            <Link to="/" className="text-gray-500 hover:text-emerald-600 cursor-pointer">خانه</Link>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
            <Link to="/products" className="text-gray-500 hover:text-emerald-600 cursor-pointer">محصولات</Link>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
            <span className="text-gray-800 font-medium">پیت ماس کانادایی پریمیوم</span>
          </nav>
        </div>
      </section>

      {/* Product Details */}
      <section className="py-12">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Product Images */}
            <div>
              <div className="mb-4">
                <img
                  src={productImages[selectedImage]}
                  alt="پیت ماس کانادایی پریمیوم"
                  className="w-full h-96 object-cover object-top rounded-2xl shadow-lg"
                />
              </div>
              <div className="grid grid-cols-4 gap-2">
                {productImages.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedImage(index)}
                    className={`border-2 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 ${
                      selectedImage === index ? 'border-emerald-500' : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <img
                      src={image}
                      alt={`تصویر ${index + 1}`}
                      className="w-full h-20 object-cover object-top"
                    />
                  </button>
                ))}
              </div>
            </div>

            {/* Product Info */}
            <div>
              <div className="mb-6">
                <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-sm font-medium">
                  واردات مستقیم از کانادا
                </span>
              </div>
              
              <h1 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
                پیت ماس کانادایی پریمیوم
              </h1>
              
              <p className="text-xl text-gray-600 mb-6 leading-relaxed">
                بستر کشت طبیعی و ارگانیک از پیت ماس کانادایی با کیفیت بالا مناسب برای کشت نشاء و گلخانه
              </p>

              {/* Rating */}
              <div className="flex items-center mb-6">
                <div className="flex items-center text-yellow-500 ml-3">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <span className="text-gray-600">۴.۹ از ۵ (۲۰۳ نظر)</span>
              </div>

              {/* Size Selection */}
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-3">انتخاب حجم:</h3>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  {sizes.map((size) => (
                    <button
                      key={size.size}
                      onClick={() => setSelectedSize(size.size)}
                      className={`p-4 border-2 rounded-xl cursor-pointer transition-all ${
                        selectedSize === size.size
                          ? 'border-emerald-500 bg-emerald-50'
                          : 'border-gray-200 hover:border-gray-300'
                      }`}
                    >
                      <div className="text-center">
                        <div className="font-semibold text-gray-800">{size.volume}</div>
                        <div className="text-emerald-600 font-bold mt-1">{size.price}</div>
                        <div className="text-gray-500 text-sm line-through">{size.originalPrice}</div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Key Features */}
              <div className="mb-8">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">ویژگی‌های کلیدی:</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-emerald-600"></i>
                    <span className="text-gray-700">کیفیت کانادایی اصل</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-emerald-600"></i>
                    <span className="text-gray-700">ظرفیت نگهداری آب بالا</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-emerald-600"></i>
                    <span className="text-gray-700">pH اسیدی مناسب</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-emerald-600"></i>
                    <span className="text-gray-700">عاری از آفات و بیماری</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-emerald-600"></i>
                    <span className="text-gray-700">تهویه مناسب</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-emerald-600"></i>
                    <span className="text-gray-700">بافت یکنواخت</span>
                  </div>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <button className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-phone-line ml-2"></i>
                  استعلام قیمت و سفارش
                </button>
                <button className="flex-1 border-2 border-emerald-600 text-emerald-600 hover:bg-emerald-50 px-6 py-3 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-download-line ml-2"></i>
                  دانلود کاتالوگ
                </button>
              </div>

              {/* Contact Info */}
              <div className="bg-gray-50 p-6 rounded-2xl">
                <h4 className="font-semibold text-gray-800 mb-3">تماس برای مشاوره:</h4>
                <div className="space-y-2">
                  <div className="flex items-center space-x-3">
                    <i className="ri-phone-line text-emerald-600"></i>
                    <span className="text-gray-700">۰۲۱۸۸۴۴۱۳۸۶</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-smartphone-line text-emerald-600"></i>
                    <span className="text-gray-700">۰۹۱۲۹۰۹۵۳۰۲</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Tabs */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'bg-emerald-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-emerald-50 border border-gray-200'
                }`}
              >
                <i className={`${tab.icon} text-lg`}></i>
                <span>{tab.name}</span>
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="bg-white rounded-3xl p-8 shadow-lg">
            {activeTab === 'overview' && (
              <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6">نمای کلی محصول</h3>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  <div>
                    <p className="text-gray-700 leading-relaxed mb-6">
                      پیت ماس کانادایی پریمیوم یکی از بهترین بسترهای کشت طبیعی و ارگانیک محسوب می‌شود که مستقیماً از کانادا وارد می‌شود. این محصول با کیفیت بالا و بافت یکنواخت، امکان رشد مطلوب گیاهان در شرایط مختلف را فراهم می‌کند.
                    </p>
                    <p className="text-gray-700 leading-relaxed mb-6">
                      پیت ماس دارای ظرفیت نگهداری آب و تهویه مناسبی است که آن را به انتخاب اول کشاورزان و باغبانان حرفه‌ای تبدیل کرده است. این محصول کاملاً طبیعی و عاری از هرگونه آفات و بیماری‌های خاکزاد است.
                    </p>
                    <div className="bg-emerald-50 p-4 rounded-xl">
                      <h4 className="font-semibold text-emerald-800 mb-2">نکته مهم:</h4>
                      <p className="text-emerald-700 text-sm">
                        پیت ماس کانادایی دارای pH اسیدی است که برای کشت بسیاری از گیاهان مناسب می‌باشد و با افزودن آهک می‌توان pH آن را تنظیم کرد.
                      </p>
                    </div>
                  </div>
                  <div>
                    <img
                      src="https://readdy.ai/api/search-image?query=seedling%20growing%20in%20Canadian%20peat%20moss%20substrate%20greenhouse%20cultivation%20healthy%20plant%20growth%20natural%20growing%20medium%20professional%20agriculture&width=500&height=400&seq=peat-growing&orientation=landscape"
                      alt="نشاء در حال رشد در پیت ماس"
                      className="w-full h-80 object-cover object-top rounded-2xl shadow-lg"
                    />
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'specifications' && (
              <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6">مشخصات فنی</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-4">مشخصات کلی:</h4>
                    <div className="space-y-3">
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">منشأ:</span>
                        <span className="font-medium">کانادا</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">رطوبت:</span>
                        <span className="font-medium">۴۵-۵۵٪</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">pH:</span>
                        <span className="font-medium">۳.۵-۴.۵</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">درجه تجزیه:</span>
                        <span className="font-medium">H2-H4</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">EC:</span>
                        <span className="font-medium">&lt; 1.0 mS/cm</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-4">ظرفیت‌ها:</h4>
                    <div className="space-y-3">
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">ظرفیت نگهداری آب:</span>
                        <span className="font-medium">۱۵-۲۰ برابر وزن</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">تخلخل کل:</span>
                        <span className="font-medium">۹۵-۹۸٪</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">تخلخل هوایی:</span>
                        <span className="font-medium">۱۰-۲۰٪</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">چگالی خشک:</span>
                        <span className="font-medium">۷۰-۱۰۰ کیلوگرم/متر مکعب</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">ماندگاری:</span>
                        <span className="font-medium">۲-۳ سال</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'usage' && (
              <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6">راهنمای استفاده</h3>
                <div className="space-y-6">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-4">نحوه آماده‌سازی:</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="space-y-4">
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">۱</div>
                          <div>
                            <h5 className="font-medium text-gray-800">باز کردن بسته‌بندی</h5>
                            <p className="text-gray-600 text-sm">بسته را در محیط باز باز کنید</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">۲</div>
                          <div>
                            <h5 className="font-medium text-gray-800">آبدهی اولیه</h5>
                            <p className="text-gray-600 text-sm">پیت ماس را با آب ولرم مرطوب کنید</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">۳</div>
                          <div>
                            <h5 className="font-medium text-gray-800">مخلوط کردن</h5>
                            <p className="text-gray-600 text-sm">به آرامی مخلوط کنید تا یکنواخت شود</p>
                          </div>
                        </div>
                      </div>
                      <div className="space-y-4">
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">۴</div>
                          <div>
                            <h5 className="font-medium text-gray-800">تنظیم pH</h5>
                            <p className="text-gray-600 text-sm">در صورت نیاز آهک اضافه کنید</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">۵</div>
                          <div>
                            <h5 className="font-medium text-gray-800">افزودن کود</h5>
                            <p className="text-gray-600 text-sm">کود پایه را اضافه کنید</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">۶</div>
                          <div>
                            <h5 className="font-medium text-gray-800">آماده برای کاشت</h5>
                            <p className="text-gray-600 text-sm">پس از ۲۴ ساعت آماده کاشت است</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="bg-blue-50 p-6 rounded-xl">
                    <h4 className="font-semibold text-blue-800 mb-3">نکات مهم:</h4>
                    <ul className="space-y-2 text-blue-700">
                      <li className="flex items-center space-x-2">
                        <i className="ri-information-line"></i>
                        <span>از آب سخت برای آبدهی اولیه استفاده نکنید</span>
                      </li>
                      <li className="flex items-center space-x-2">
                        <i className="ri-information-line"></i>
                        <span>پیت ماس را در جای خشک و خنک نگهداری کنید</span>
                      </li>
                      <li className="flex items-center space-x-2">
                        <i className="ri-information-line"></i>
                        <span>قبل از استفاده pH را بررسی کنید</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'applications' && (
              <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6">کاربردها</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-seedling-line text-emerald-600 text-xl"></i>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-2">کشت نشاء</h4>
                    <p className="text-gray-600 text-sm">مناسب برای کشت انواع نشاء سبزیجات و گل</p>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-home-garden-line text-emerald-600 text-xl"></i>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-2">گلخانه‌ها</h4>
                    <p className="text-gray-600 text-sm">بستر کشت مناسب برای گلخانه‌های تجاری</p>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-drop-line text-emerald-600 text-xl"></i>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-2">هیدروپونیک</h4>
                    <p className="text-gray-600 text-sm">استفاده در سیستم‌های کشت بدون خاک</p>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-plant-line text-emerald-600 text-xl"></i>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-2">نهالستان‌ها</h4>
                    <p className="text-gray-600 text-sm">پرورش نهال‌های میوه و جنگلی</p>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-flower-line text-emerald-600 text-xl"></i>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-2">گل‌سرای</h4>
                    <p className="text-gray-600 text-sm">کشت انواع گل‌های زینتی و آپارتمانی</p>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-microscope-line text-emerald-600 text-xl"></i>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-2">تحقیقات</h4>
                    <p className="text-gray-600 text-sm">استفاده در مراکز تحقیقاتی کشاورزی</p>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'benefits' && (
              <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6">مزایا و فواید</h3>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-4">مزایای کشاورزی:</h4>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-3">
                        <i className="ri-drop-line text-emerald-600"></i>
                        <span className="text-gray-700">ظرفیت نگهداری آب بالا</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-air-line text-emerald-600"></i>
                        <span className="text-gray-700">تهویه مناسب ریشه</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-shield-check-line text-emerald-600"></i>
                        <span className="text-gray-700">عاری از آفات و بیماری</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-recycle-line text-emerald-600"></i>
                        <span className="text-gray-700">کاملاً طبیعی و ارگانیک</span>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-4">مزایای اقتصادی:</h4>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-3">
                        <i className="ri-seedling-line text-emerald-600"></i>
                        <span className="text-gray-700">افزایش درصد جوانه‌زنی</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-growth-line text-emerald-600"></i>
                        <span className="text-gray-700">رشد سریع‌تر گیاهان</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-money-dollar-circle-line text-emerald-600"></i>
                        <span className="text-gray-700">کاهش هزینه کود</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-time-line text-emerald-600"></i>
                        <span className="text-gray-700">ماندگاری طولانی مدت</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="mt-8 bg-emerald-50 p-6 rounded-xl">
                  <h4 className="font-semibold text-emerald-800 mb-3">چرا پیت ماس کانادایی ما را انتخاب کنید؟</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex items-center space-x-2">
                      <i className="ri-award-line text-emerald-600"></i>
                      <span className="text-emerald-700">واردات مستقیم از کانادا</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <i className="ri-verified-badge-line text-emerald-600"></i>
                      <span className="text-emerald-700">گواهی کیفیت بین‌المللی</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <i className="ri-customer-service-2-line text-emerald-600"></i>
                      <span className="text-emerald-700">مشاوره فنی رایگان</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <i className="ri-truck-line text-emerald-600"></i>
                      <span className="text-emerald-700">ارسال به سراسر کشور</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Related Products */}
      <section className="py-16">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">محصولات مرتبط</h2>
            <p className="text-gray-600">سایر محصولات مورد نیاز گلخانه شما</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-product-shop>
            {relatedProducts.map((product) => (
              <div key={product.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">{product.name}</h3>
                  <p className="text-emerald-600 font-bold mb-4">{product.price}</p>
                  <Link
                    to={`/products/${product.id}`}
                    className="block w-full bg-emerald-600 hover:bg-emerald-700 text-white text-center py-2 rounded-full font-medium transition-colors cursor-pointer"
                  >
                    مشاهده جزئیات
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-emerald-600">
        <div className="container mx-auto px-4 lg:px-8 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">آماده سفارش هستید؟</h2>
          <p className="text-xl mb-8 text-emerald-100">
            با تیم متخصص ما تماس بگیرید و مشاوره رایگان دریافت کنید
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-emerald-600 hover:bg-gray-100 px-8 py-3 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-phone-line ml-2"></i>
              تماس برای سفارش
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-emerald-600 px-8 py-3 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-whatsapp-line ml-2"></i>
              چت در واتساپ
            </button>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
